<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    confirm-text="保存"
    :title="title"
    width="20%"
    :confirm-disable="false"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="100px"
      >
        <el-form-item
          label="原密码"
          prop="oldPassword"
        >
          <el-input
            v-model="createForm.oldPassword"
            show-password
          />
        </el-form-item>
        <el-form-item
          label="新密码"
          prop="newPassword"
        >
          <el-input
            v-model="createForm.newPassword"
            show-password
          />
        </el-form-item>
        <el-form-item
          label="确认新密码"
          prop="newPasswordConfirm"
        >
          <el-input
            v-model="createForm.newPasswordConfirm"
            show-password
          />
        </el-form-item>
      </el-form>
    </div>
  </custome-Dialog>
</template>
<script>
import md5 from 'js-md5';
import customeDialog from '@/components/common/dialog.vue';
import axClient from '@/services';

export default {
  name: 'CourseCategory',
  components: { customeDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: '修改密码',
      cancelText: '取消',
      createForm: {
        oldPassword: null,
        newPassword: null,
        newPasswordConfirm: null,
      },
      creatRules: {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' },
        ],
        newPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' },
        ],
        newPasswordConfirm: [
          { required: true, message: '请输入原密码', trigger: 'blur' },
        ],
      },
    };
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.createForm.clearValidate();
          this.$refs.createForm.resetFields();
        });
      }
    },
  },
  methods: {
    close() {
      this.$emit('update:dialogVisible', false);
      this.$emit('close');
    },
    confirm() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          if (this.createForm.newPassword !== this.createForm.newPasswordConfirm) {
            return;
          }
          const data = await axClient.account.updatePassword({
            newPassword: md5(this.createForm.newPassword),
            oldPassword: md5(this.createForm.oldPassword),
          });
          if (!data) return;
          this.$message.success('修改密码成功');
          this.$emit('update:dialogVisible', false);
          this.$emit('confirm');
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  min-height: 200px;
  .wx-info {
    padding: 0 0 0 0;
    text-align: left;
    .item {
      margin-bottom: 15px;
      span {
        font-size: 12px;
        color: $--base-color-black;
        &:last-child {
          padding-left: 8px;
        }
      }
    }
  }
}
</style>
